// @flow

import { observer } from "mobx-react";
import React from "react";

import TimelineItem from "app/models/TimelineItem";

import "./TimelineBarRange.scss";

type Props = {
    item: TimelineItem,
    progress?: number,
    selected?: boolean
};

@observer
export default class TimelineBarRange extends React.Component<Props> {
    render() {
        let classes = ["TimelineBarRange"];

        if (this.props.selected) {
            classes.push("TimelineBarRange--selected");
        }

        return (
            <div className={classes.join(" ")}>
                <div className="TimelineBarRange__timeSpan">
                    <div className="TimelineBarRange__timeSpan__inner"></div>
                    <i className="fa fa-caret-down" aria-hidden="true"></i>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineBarRange/TimelineBarRange.js